import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.string.replace-all.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "contract-detail-btn"
};
const _hoisted_2 = {
  key: 1,
  class: "contract-detail-audit"
};
const _hoisted_3 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_4 = {
  style: {
    "margin-left": "30px"
  }
};
const _hoisted_5 = {
  key: 2,
  style: {
    "width": "50%"
  }
};
const _hoisted_6 = {
  key: 3,
  class: "contract-detail-monitor"
};
const _hoisted_7 = {
  key: 4,
  class: "contract-detail-monitor"
};
const _hoisted_8 = {
  key: 5,
  class: "contract-detail-monitor"
};
const _hoisted_9 = {
  key: 6,
  class: "contract-detail-monitor"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref, toRefs } from "vue";
import apis from "@/api";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import download from "@/utils/download";
import AdvertUpload from '@/components/Upload';
import { commitAudit, deleteImageById, getByRoleId, inputAsset, pickDetail, updateStateByRoleId } from "@/api/modules/advert";
import { USERINFO } from "@/store/mutation-types";
import DialogAssetsLib from "@/views/AssetsLib/DialogAssetsLib.vue";
export default {
  __name: 'AdvertLaunchDetail',
  props: {
    roleId: {
      type: String,
      default: ''
    },
    roleFlag: {
      type: String,
      default: ''
    },
    advertLaunch: {
      type: Object
    },
    currentAction: {
      type: String
    }
  },
  emits: ['submit'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const detailLoading = ref(false);
    const downLoading = ref(false);
    const {
      exportSettlementExcel
    } = download();
    const assetsLib = ref();
    const uploadImageVisible = ref(false);
    const uploadMonitorVisible = ref(false);
    const uploadTitle = ref('上传');
    const dialogVisible = ref(false);
    const compareDisabled = ref(false);
    const importVisible = ref(false);
    const userInfo = ref({});
    const detailAddVisible = computed(() => {
      if (props.currentAction === 'detailAdd') {
        return true;
      }
      return false;
    });
    const detailEditVisible = computed(() => {
      if (props.currentAction === 'detailEdit') {
        return true;
      }
      return false;
    });
    const detailMonitorVisible = computed(() => {
      if (props.currentAction === 'detailMonitor') {
        return true;
      }
      return false;
    });
    const detailCompanyVisible = computed(() => {
      if (props.currentAction === 'companyPick') {
        return true;
      }
      return false;
    });
    const realityUploadVisible = computed(() => {
      if (props.currentAction === 'realityUpload') {
        return true;
      }
      return false;
    });
    const detailAuditVisible = computed(() => {
      if (props.currentAction === 'detailAudit') {
        return true;
      }
      return false;
    });
    const checkRecordCompareVisible = computed(() => {
      if (props.currentAction === 'checkRecordCompare') {
        return true;
      }
      return false;
    });
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const props = __props;
    const data = reactive({
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      audit: {
        launchAuditState: 0,
        auditDescription: null
      },
      DetailSettlement: {},
      uploadPulicFiles: [],
      uploadActionRow: {},
      uploadImageType: '',
      assetsActionRow: {},
      multipleSelection: [],
      company: {}
    });
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const selectable = (row, index) => {
      return row.claimStatus !== 1;
    };
    const loadData = () => {
      const params = {
        advertLaunchId: props.advertLaunch.id,
        roleId: props.roleId,
        roleFlag: props.roleFlag,
        ...data.pagination
      };
      if (props.currentAction === 'detailAudit') {
        params.roleId = props.advertLaunch.currentRoleId;
        params.roleFlag = '0';
      }
      detailLoading.value = true;
      apis.getAdvertLaunchMonitorDetailPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        detailLoading.value = false;
      });
      if (props.advertLaunch.examineState !== 0 && props.roleFlag === '0') {
        apis.getByRoleId({
          monitorId: props.advertLaunch.id,
          roleId: props.roleId
        }).then(res => {
          if (res.success) {
            data.company = res.data;
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const dialogClose = () => {
      dialogVisible.value = false;
    };
    const handleSelectionChange = val => {
      data.multipleSelection = val;
    };
    // 保存选择的素材图片
    const handleSelectedChange = assets => {
      dialogVisible.value = false;
      const params = [];
      const pic = {
        advertLaunchId: data.assetsActionRow.advertLaunchId,
        advertLaunchDetailId: data.assetsActionRow.id,
        imgId: assets[0].id,
        imgName: assets[0].assetsName,
        imgUrl: assets[0].srcInnUrl,
        type: 3
      };
      params.push(pic);
      apis.savePublicImages(params).then(res => {
        if (res.success) {
          ElMessage.success("选取成功");
        }
      }).finally(() => {
        loadData();
      });
    };
    const selectAssetsImage = row => {
      dialogVisible.value = true;
      assetsLib.value.fetchData();
      data.assetsActionRow = row;
    };
    // 删除选择的素材图片
    const deleteAssetsImage = id => {
      apis.deleteImageById({
        imageId: id
      }).then(res => {
        if (res.success) {
          ElMessage.success("删除成功");
        }
      }).finally(() => {
        loadData();
      });
    };
    // const downloadSettlements = () => {
    //   downLoading.value = true
    //   exportSettlementExcel(props.contract.id, props.contract.contractName + '.xlsx').then(res => {
    //     downLoading.value = false
    //   }).finally(() => {
    //     downLoading.value = false
    //   })
    // }

    const handleDownload = () => {
      window.open("/filesvc/xw-assets/广告投放计划表模板.xlsx");
      //window.open("http://10.174.80.86:7000/filesvc/xw-assets/合同费用列表模板.xlsx")
    };
    const fileUpload = params => {
      importVisible.value = true;
      const formData = new FormData();
      formData.append("advertLaunchId", props.advertLaunch.id);
      formData.append("fileMap", params.file);
      const advertLaunchId = props.advertLaunch.id;
      apis.deleteByAdvertLaunchId({
        'advertLaunchId': advertLaunchId
      }).then(res => {
        if (!res.success) {
          ElMessage.error("更新失败!,请重新导入");
          return;
        } else {
          apis.importAdvertLaunchDetailExcel(formData).then(res => {
            if (res.code == 200) {
              ElMessage.success("文件导入成功!");
            } else {
              ElMessage.error(res.msg);
            }
          }).catch(err => {
            ElMessage.error(err);
          }).finally(() => {
            importVisible.value = false;
            loadData();
          });
        }
      }).catch(err => {
        importVisible.value = false;
        ElMessage.error(err);
      }).finally(() => {
        // loadData()
      });
    };
    const handleUpImage = (row, type) => {
      data.uploadImageType = type;
      if (type === 1) {
        uploadTitle.value = '上传延展图片';
      } else if (type === 2) {
        uploadTitle.value = '上传监测图片';
      } else {
        uploadTitle.value = '上传上画照片';
      }
      data.uploadActionRow = row;
      uploadImageVisible.value = true;
    };
    const handlerUploadImageSuccess = files => {
      uploadImageVisible.value = false;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const item = {
            imgId: f.id,
            imgName: f.fileName,
            imgUrl: f.relativeUrl
          };
          uploadFiles.push(item);
        });
        data.uploadPulicFiles = data.uploadPulicFiles.concat(uploadFiles);
        //提交参数
        let params = [];
        data.uploadPulicFiles.forEach(p => {
          const b = {
            advertLaunchId: data.uploadActionRow.advertLaunchId,
            advertLaunchDetailId: data.uploadActionRow.id,
            imgId: p.imgId,
            imgName: p.imgName,
            imgUrl: p.imgUrl,
            type: data.uploadImageType
          };
          params.push(b);
        });
        //将发布图片存入数据数据库
        apis.savePublicImages(params).then(res => {
          if (res.success) {
            console.log("保存投放成功");
            if (data.uploadImageType == 1) {
              if (data.uploadPulicFiles && data.uploadPulicFiles.length > 0) {
                let assertParam = [];
                let now = new Date();
                let end = new Date();
                end.setFullYear(end.getFullYear() + 10);
                data.uploadPulicFiles.forEach(aa => {
                  const a = {
                    id: aa.imgId,
                    assetsName: aa.imgName,
                    positionId: 'toufang',
                    positionName: '投放',
                    srcInnUrl: aa.imgUrl,
                    srcTyp: 1,
                    subtype: '监测',
                    bgnDate: now.toLocaleDateString().replaceAll('/', '-') + ' 00:00:00',
                    endDate: end.toLocaleDateString().replaceAll('/', '-') + ' 00:00:00',
                    status: 1,
                    needName: props.advertLaunch.taskName,
                    needUser: data.userName
                  };
                  assertParam.push(a);
                });
                apis.inputAsset(assertParam).then(res => {
                  if (res.success) {
                    console.log("toufang 同步至素材库并同步能开");
                  }
                }).catch(err => {}).finally(() => {});
              }
            }
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {
          data.uploadPulicFiles = [];
          data.uploadActionRow = {};
          data.uploadImageType = '';
          loadData();
        });

        // if(data.uploadImageType == 1){
        //   if (data.uploadPulicFiles && data.uploadPulicFiles.length > 0){
        //     let assertParam = []
        //     let now = new Date()
        //     let end = new Date()
        //     end.setFullYear(end.getFullYear()+10)
        //     data.uploadPulicFiles.forEach( aa => {
        //       const a = {
        //         id:aa.imgId,
        //         assetsName:aa.imgName,
        //         positionId: 'toufang',
        //         positionName: '投放',
        //         srcInnUrl: aa.imgUrl,
        //         srcTyp:1,
        //         subtype:'监测',
        //         bgnDate: now.toLocaleDateString().replaceAll('/', '-')+' 00:00:00',
        //         endDate: end.toLocaleDateString().replaceAll('/', '-')+' 00:00:00',
        //         status:1,
        //         needName:props.advertLaunch.taskName,
        //         needUser:data.userName,
        //       }
        //       assertParam.push(a)
        //     })
        //     apis.inputAsset(assertParam).then((res) => {
        //       if (res.success) {
        //         console.log("toufang 同步至素材库并同步能开")
        //       }
        //     }).catch(err => {}).finally(() => {
        //       data.uploadPulicFiles = []
        //       data.uploadActionRow = {}
        //       data.uploadImageType = ''
        //     })
        //   }
        // }
      } else {
        ElMessage.error('请先上传图片!');
      }
    };
    const getUserInfo = () => {
      userInfo.value = JSON.parse(window.localStorage.getItem(USERINFO));
      data.userName = userInfo.value.userName;
    };
    const deleteConfirm = item => {
      ElMessageBox.alert('确定要删除单条明细吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showCancelButton: true
      }).then(() => {
        handleDeleteDetail(item);
      }).catch(() => {});
    };
    const handleDeleteDetail = row => {
      apis.deleteAdvertLaunchMonitorDetail({
        'id': row.id,
        'advertLaunchId': row.advertLaunchId
      }).then(res => {
        if (res.success) {
          ElMessage.success('删除明细成功');
          //加载商品
          loadData();
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const handleSubmit = () => {
      if (!data.tableData || data.tableData.length == 0) {
        ElMessage.error("请先导入投放任务明细表!");
        return;
      }
      for (const item of data.tableData) {
        if (!item.assetsImage || item.assetsImage.length === 0) {
          ElMessage.error("请先选择素材图片!");
          return;
        }
      }
      if (props.advertLaunch.monitorState !== -1 && props.advertLaunch.monitorState !== 5) {
        ElMessage.error("该任务已过提审阶段!");
        return;
      }
      apis.commitAudit(props.advertLaunch).then(res => {
        if (res.success) {
          ElMessage.success('提交审核成功!');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        emits('submit');
      });
    };
    const handleAudit = () => {
      const param = {
        examineState: data.audit.launchAuditState,
        examineOpinion: data.audit.auditDescription,
        roleId: props.advertLaunch.currentRoleId,
        monitorId: props.advertLaunch.id
      };
      apis.updateStateByRoleId(param).then(res => {
        if (res.success) {
          ElMessage.success("提交成功！");
          emits('submit');
          return;
        }
        ElMessage.error(res.msg);
      });
    };
    const handlePickCompany = () => {
      if (data.multipleSelection.length === 0) {
        ElMessage.error('未选择认领条目');
        return;
      }
      ElMessageBox.confirm('确定认领所选投放详细吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.pickDetail({
          roleId: props.roleId
        }, data.multipleSelection).then(res => {
          if (res.success) {
            ElMessage.success("认领成功");
            emits('submit');
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
      });
    };
    const handleConfirm = () => {
      ElMessageBox.confirm('确定提交当前投放任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.confirmDetail({
          roleId: props.roleId,
          monitorId: props.advertLaunch.id
        }).then(res => {
          if (res.success) {
            ElMessage.success("提交成功");
            emits('submit');
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
      });
    };
    const handleEdit = () => {
      const data = {
        examineState: 2,
        roleId: props.roleId,
        monitorId: props.advertLaunch.id
      };
      apis.updateStateByRoleId(data).then(res => {
        if (res.success) {
          ElMessage.success("提交成功！");
          emits('submit');
          return;
        }
        ElMessage.error(res.msg);
      });
    };
    const handleMonitorCompare = () => {
      compareDisabled.value = true;
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading 比对中',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const param = {
        advertLaunchId: props.advertLaunch.id
      };
      if (props.advertLaunch.monitorState === 11) {
        param.checkRecordFlag = 1; //检查复核比对标记
      } else {
        param.checkRecordFlag = 0;
      }
      if (props.advertLaunch.monitorState != 2 && props.advertLaunch.monitorState != 11) {
        ElMessage.error("监测状态有误!");
        compareDisabled.value = false;
        loadingInstance.close();
        return;
      }
      apis.handleMonitorCompare(param).then(res => {
        if (res.success) {
          ElMessage.success('任务提交成功');
          emits('submit');
        } else {
          ElMessage.error(res.msg);
          compareDisabled.value = false;
        }
      }).catch(err => {
        ElMessage.error(err);
        compareDisabled.value = false;
      }).finally(() => {
        loadingInstance.close();
        // emits('submit')
      });
    };
    onMounted(() => {
      loadData();
      getUserInfo();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [detailAddVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_upload, {
        style: {
          "margin-left": "12px"
        },
        ref: "upload",
        action: "",
        "http-request": fileUpload,
        "show-file-list": false,
        "auto-upload": true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          disabled: importVisible.value
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("导入", -1)]))]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }, 512), _createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        onClick: handleDownload
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("下载模版", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("提交审核", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), detailAuditVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
        modelValue: data.audit.auditDescription,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.audit.auditDescription = $event),
        placeholder: "请输入审核意见"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_radio_group, {
        modelValue: data.audit.launchAuditState,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.audit.launchAuditState = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("通过", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 3
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("不通过", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: handleAudit
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("提交", -1)]))]),
        _: 1
      })])])) : _createCommentVNode("", true), data.company.examineOpinion && __props.roleFlag === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_descriptions, {
        title: "审批状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
          label: "状态"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.company.examineState !== 1 ? '不通过' : '通过'), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "审批人"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.company.examinePerson), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "审批意见"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.company.examineOpinion), 1)]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), detailMonitorVisible.value || checkRecordCompareVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleMonitorCompare,
        disabled: compareDisabled.value
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("比对", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true), detailCompanyVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handlePickCompany
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("提交", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), realityUploadVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleConfirm
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("提交", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), detailEditVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleEdit
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("提交投放任务", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [detailCompanyVisible.value ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          type: "selection",
          selectable: selectable
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "mediaType",
          label: "媒体类型"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "modality",
          label: "形式"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "address",
          label: "投放位置"
        }), _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "resQuantity",
          label: "资源总量"
        }), _createVNode(_component_el_table_column, {
          prop: "unitPriceExcludingTax",
          label: "不含税单价/元"
        }), _createVNode(_component_el_table_column, {
          prop: "estimatePriceExcludingTax",
          label: "预估金额(季度不含税)"
        }), _createVNode(_component_el_table_column, {
          prop: "launchDateBgn",
          label: "投放日期开始"
        }), _createVNode(_component_el_table_column, {
          prop: "launchDateEnd",
          label: "投放日期结束"
        }), _createVNode(_component_el_table_column, {
          prop: "position",
          label: "具体点位"
        }), __props.roleFlag !== '0' && __props.roleFlag !== '2' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          prop: "assetsImage",
          label: "素材图片"
        }, {
          default: _withCtx(scope => [scope.row.assetsImage && scope.row.assetsImage.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.assetsImage, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createVNode(_component_el_image, {
              src: item.imgUrl,
              "preview-src-list": [item.imgUrl],
              "preview-teleported": ""
            }, null, 8, ["src", "preview-src-list"]), __props.roleFlag === '1' && __props.advertLaunch.monitorState === -1 && detailAddVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => deleteAssetsImage(item.id)
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [__props.roleFlag === '1' && __props.advertLaunch.monitorState === -1 && detailAddVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => selectAssetsImage(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("选择", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]))]),
          _: 1
        })) : _createCommentVNode("", true), !detailAddVisible.value && !detailCompanyVisible.value ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          prop: "publicImage",
          label: "延展图片"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.publicImage, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createVNode(_component_el_image, {
              src: item.imgUrl,
              "preview-src-list": [item.imgUrl],
              "preview-teleported": ""
            }, null, 8, ["src", "preview-src-list"]), detailEditVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => deleteAssetsImage(item.id)
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]);
          }), 128))])]),
          _: 1
        })) : _createCommentVNode("", true), !detailAddVisible.value && __props.roleFlag !== '2' && !detailEditVisible.value && !detailCompanyVisible.value ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 3,
          prop: "publicImage",
          label: "上画照片"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.realityImage, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createVNode(_component_el_image, {
              src: item.imgUrl,
              "preview-src-list": [item.imgUrl],
              "preview-teleported": ""
            }, null, 8, ["src", "preview-src-list"]), realityUploadVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => deleteAssetsImage(item.id)
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]);
          }), 128))])]),
          _: 1
        })) : _createCommentVNode("", true), __props.roleFlag == '2' || __props.roleFlag == '3' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 4,
          prop: "monitorImage",
          label: "监测图片"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.monitorImage, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [_createVNode(_component_el_image, {
              src: item.imgUrl,
              "preview-src-list": [item.imgUrl],
              "preview-teleported": ""
            }, null, 8, ["src", "preview-src-list"]), detailMonitorVisible.value || checkRecordCompareVisible.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => deleteAssetsImage(item.id)
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]);
          }), 128))])]),
          _: 1
        })) : _createCommentVNode("", true), detailMonitorVisible.value || detailEditVisible.value || realityUploadVisible.value || checkRecordCompareVisible.value ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 5,
          label: "操作",
          width: "150"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_12, [__props.roleFlag == '0' && (__props.advertLaunch.examineState === 4 || __props.advertLaunch.examineState === 1) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            size: "small",
            type: "primary",
            onClick: _withModifiers($event => handleUpImage(scope.row, 1), ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" 上传延展图片 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), __props.roleFlag == '0' && __props.advertLaunch.examineState == 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            size: "small",
            type: "primary",
            onClick: _withModifiers($event => handleUpImage(scope.row, 4), ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" 上传上画照片 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), __props.roleFlag == '2' && __props.advertLaunch.monitorState == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            link: "",
            size: "small",
            type: "primary",
            onClick: _withModifiers($event => handleUpImage(scope.row, 2), ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" 上传监测图片 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), __props.roleFlag == '2' && __props.advertLaunch.monitorState == 11 && scope.row.hasCheck === 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            link: "",
            size: "small",
            type: "primary",
            onClick: _withModifiers($event => handleUpImage(scope.row, 2), ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" 上传监测图片 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, detailLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_unref(AdvertUpload), {
        visible: uploadImageVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => uploadImageVisible.value = $event),
        title: uploadTitle.value,
        multiple: true,
        onUploadSuccess: handlerUploadImageSuccess
      }, null, 8, ["visible", "title"])], 64);
    };
  }
};